import { ExportSite } from "constants/exportSites";

export const isAuctionPlusCompliantBySaleLotComparator =
  isAuctionsPlusCompliant =>
  ([ignored, isAuctionsPlusCompliantBySaleLot]) =>
    isAuctionsPlusCompliantBySaleLot[ExportSite.AUCTIONS_PLUS] ===
    isAuctionsPlusCompliant[0];

export const isStockLiveCompliantBySaleLotComparator =
  isStockLiveCompliant =>
  ([ignored, isStockLiveCompliantBySaleLot]) =>
    isStockLiveCompliantBySaleLot[ExportSite.STOCK_LIVE] ===
    isStockLiveCompliant[0];
